module.exports = __webpack_public_path__ + "img/31_25.dc05372f.png";